import { type MenuItem } from '@ics-portal/guardian';
import { type ReactNode, useMemo, useState } from 'react';
import InfoCardWrapper from '@components/_molecules/InfoCards/Layout/InfoCardWrapper';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { type RequestProps } from '../../models/RequestProps';
import { EditRequestContent } from './EditRequestContent';
import { RequestDetailsContent } from './RequestDetailsContent';

export function RequestDetailsTab({ request }: RequestProps): ReactNode {
    const [editMode, setEditMode] = useState<boolean>();
    const title = useMemo(
        () => (editMode ? 'Edit Request' : 'Details'),
        [editMode],
    );

    const actions: MenuItem[] = useMemo(() => {
        if (editMode) {
            return [];
        }

        const newActions: MenuItem[] = [];

        if (
            request.statusCode ===
            ComponentCreateRequestStatusCode.ApprovalPending
        ) {
            newActions.push({
                label: 'Edit',
                command: () => {
                    setEditMode(true);
                },
            });
        }

        return newActions;
    }, [request, editMode]);

    return (
        <InfoCardWrapper title={title} actions={actions} className="pb-0">
            {!editMode && <RequestDetailsContent request={request} />}
            {editMode ? (
                <EditRequestContent
                    request={request}
                    disableEditMode={() => {
                        setEditMode(false);
                    }}
                />
            ) : null}
        </InfoCardWrapper>
    );
}
